import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import API_URL from "../../api/API";
import { useBusinessAuthContext } from "./useBusinessAuthContext";
import leftImg from "../../images/login-left.png";
import logo from "../../images/svg/sidebar-logo.svg";
import arrowR from "../../images/svg/arrow-right.svg";


const BusinessLogin = () => {
  const navigate = useNavigate();
  const { dispatch } = useBusinessAuthContext();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await fetch(API_URL.BUSINESS_LOGIN, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();
      setLoading(false);

      if (data.success) {
        //localStorage.setItem("business", JSON.stringify(data)); - added in dispatch
        //dispatch({ type: "BUSINESS_LOGIN", payload: data });
        //navigate(`/business/dashboard`);

        dispatch({ type: "BUSINESS_LOGIN", payload: data });        

        // 👉 call waiver check
        const res = await fetch(
          `${API_URL.BUSINESS_WAIVERS_EXISTS}?businessId=${data.id}`,
          {
            headers: {
              Authorization: `Bearer ${data.token}`,
              "x-session-id": data.sessionId,
              "x-frontend-url": window.location.pathname,
            },
          }
        );

        const waiverData = await res.json();

        // 👉 conditional redirect
        if (waiverData.success && !waiverData.hasWaivers) {
          navigate(`/business/waivers`);
        } else {
          navigate(`/business/dashboard`);
        }

      } else {
        setError(data.message || "Login failed.");
      }
    } catch (err) {
      console.error("Login error:", err);
      setError("Server error. Please try again.");
      setLoading(false);
    }
  };

  return (
    <div className="lg:h-screen bg-white flex max-lg:flex-col items-stretch">
      {/* <div className=""> */}
      <div className="block h-96 lg:h-full w-full">
        {/* <div> */}
        <img
          src={leftImg}
          alt="leftImg"
          className="object-cover object-center h-full w-full"
        />
        {/* </div> */}
      </div>
      <div className="w-full lg:w-1/2 xl:w-[510px] 2xl:w-[600px] 3xl:w-[710px] overflow-auto flex-none flex flex-col justify-center px-5 lg:px-10 py-10">
        <div className="w-full max-w-xl md:max-w-2xl lg:max-w-md mx-auto">
          <div className="mb-10 lg:mb-16">
            <Link to="/" className="block w-[206px]">
              <img src={logo} alt="logo" className="w-full h-full" />
            </Link>
          </div>

          <h2 className="text-black font-normal text-[32px] leading-snug mb-4">
            Business Login
          </h2>

          <form onSubmit={handleLogin} className="space-y-4">
            <div>
              <label className="block mb-1 text-foreground">
                Email Address
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full rounded-14 bg-[#F7F7F5] outline-none px-4 py-3"
              />
            </div>

            <div>
              <label className="block mb-1 text-foreground">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full rounded-14 bg-[#F7F7F5] outline-none px-4 py-3"
              />
            </div>

            {error && <p className="text-red-600 text-sm">{error}</p>}

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-highlited rounded-full text-black font-medium p-3 md:p-4 hover:bg-[#D5AA00] inline-flex justify-center items-center gap-3 transition"
            >
              {loading ? "Logging in..." : "Login"}
                              <img src={arrowR} alt="arrowR" className="w-3 mt-0.5" />

            </button>
          </form>

          {/* Register link */}
          <div className="mt-4 text-center">
            <p className="text-center text-sm text-commonText">
              Don’t have an account?{" "}
              <Link
                to="/business/register"
                className="text-black hover:underline transition"
              >
                Register here
              </Link>
            </p>

            <Link
              href="/"
              className="text-black text-center text-sm hover:underline transition"
            >
              Forgot password?
            </Link>
          </div>
        </div>
      </div>
      {/* </div> */}
    </div>
  );
};

export default BusinessLogin;
